import { FC, ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
   onClick?: () => void;
   divider?: boolean;
   active?: boolean;
   children: ReactNode;
}

export const TableRow: FC<Props> = ({ onClick, children, divider = false, active = false }) => (
   <tr
      data-testid={`table-row${divider ? '--divider' : ''}${active ? '--active' : ''}`}
      onClick={onClick}
      className={classNames(
         divider && `border-b-component-data-display-table-border-width border-b-component-data-display-table-color-border`,
         onClick && 'cursor-pointer',
         active && 'bg-theme-color-bg-inset'
      )}
   >
      {children}
   </tr>
);
